import { YPaymentAmount } from '../y/amount';
import { $api } from '../y/api';
import { YMonthSpec } from '../y/types';

export interface EGermanVatEntry {
    month: YMonthSpec;
    cost_19: YPaymentAmount;
    cost_7: YPaymentAmount;
    cost_0: YPaymentAmount;
    revenue: YPaymentAmount;
}

export function eGermanVatGet(): Promise<EGermanVatEntry[]> {
    return $api.GET<EGermanVatEntry[]>(`accounting/german_vat`);
}
